import { Injectable } from '@angular/core';


import { Consorcio } from '../model/Consorcio'; 
import { UsuarioSucursal } from '../model/usuario-sucursal';
import { Usuario } from '../model/usuario';


import { Http, Response, RequestOptions, Headers   } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable }     from 'rxjs/Observable';

import { UtilitiesService } from '../services/utilities.service'


@Injectable()
export class UsuarioSucursalService {

  constructor(
    private _http:Http,
    private _utilities:UtilitiesService
  ) {  }


  findUsuarioSucursal(usuario:Usuario) : Observable<UsuarioSucursal[]> {

    let json = {   "Metodo": "findUsuarioSucursal",   "Datos": usuario };

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());       
 
  }
  
  public insert(usuarioSucursal:UsuarioSucursal){
   
    let json = {   "Metodo": "postUsuarioSucursal",   "Datos": usuarioSucursal };

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());

}

public delete(usuarioSucursal:UsuarioSucursal){
   
    let json = {   "Metodo": "deleteUsuarioSucursal",   "Datos": usuarioSucursal  };

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());
}


}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/services/usuario-sucursal.service.ts